/** "Tonight's prizes brought to you by …" — only for a player at home, and
 *  only once a sponsor has been assigned for tonight. Nothing is drawn for an
 *  in-bar player: a table's prizes still come from its own venue.
 */
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

const ORIGIN = typeof window !== 'undefined' ? window.location.origin : '';

export const GoalSponsorLine = ({ cardId, deviceId, atHome }) => {
    const { t } = useTranslation();
    const [sponsor, setSponsor] = useState(null);

    useEffect(() => {
        if (!atHome || !deviceId) return;
        let gone = false;
        (async () => {
            try {
                const res = await axios.get(
                    `${ORIGIN}/api/goal-game/public/${cardId}/sponsor?device_id=${encodeURIComponent(deviceId)}`);
                if (!gone) setSponsor(res.data?.sponsor || null);
            } catch (_e) { /* nothing drawn */ }
        })();
        return () => { gone = true; };
    }, [cardId, deviceId, atHome]);

    if (!sponsor) return null;
    const logo = sponsor.logo_url
        ? (sponsor.logo_url.startsWith('http') ? sponsor.logo_url : `${ORIGIN}${sponsor.logo_url}`)
        : null;

    return (
        <p className="mb-3 flex items-center justify-center gap-2 text-xs opacity-80"
           data-testid="goal-sponsor-line">
            <span>{t('goalGame.sponsorBroughtBy')}</span>
            {logo ? <img src={logo} alt={sponsor.name} className="h-5 object-contain" />
                : <span className="font-bold">{sponsor.name}</span>}
        </p>
    );
};

export default GoalSponsorLine;
